import { TICKER } from "@/data/content";

export default function Marquee() {
  const items = [...TICKER, ...TICKER];
  return (
    <div className="relative border-y border-[var(--line)] py-5 overflow-hidden bg-[var(--bg-soft)] z-10">
      <div className="marquee">
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="px-6 text-lg sm:text-xl text-[var(--ink-dim)] whitespace-nowrap">
              {t}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--accent)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
